// extracted by mini-css-extract-plugin
export default {"modelFormActions":"legacy_form___modelFormActions___d47b36ef"};